/** @jsxImportSource @emotion/react */
import Text from '@Text';
import { useSelector } from 'react-redux';
import { Grid, useTheme } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import useGetExperimentName from '../../Hooks/useGetExperimentName/useGetExperimentName';
import makeSubmissionBlockPageStyling from './makeSubmissionBlockPageStyling';

/**
 * This component will be shown when a customer has passed a page with a submission block on it.
 */
const SubmissionBlockPage = () => {
  const { currentPage } = useSelector((store) => store.navigation);
  const { submissionBlocks } = useSelector((store) => store.submission);
  const currentBlock = submissionBlocks.find(
    (block) => block.page < currentPage
  );

  const theme = useTheme();
  const styling = makeSubmissionBlockPageStyling();

  const textExperimentName = useGetExperimentName({
    componentName: 'Text',
  });

  if (!currentBlock) {
    return null;
  }

  return (
    <Grid
      container
      direction="column"
      justifyContent="center"
      alignItems="center"
      data-testid="submissionBlockPageContainer"
      marginTop={theme.mvf.spacing.medium}
      spacing={theme.mvf.spacing.tiny}
    >
      <Grid item>
        <ErrorOutlineIcon css={styling.icon} />
      </Grid>
      <Grid item>
        <Text variant="header" experimentName={textExperimentName}>
          {currentBlock.message}
        </Text>
      </Grid>
    </Grid>
  );
};

export default SubmissionBlockPage;
